import { render, staticRenderFns } from "./importpressure.vue?vue&type=template&id=5135e5ba&"
import script from "./importpressure.vue?vue&type=script&lang=ts&"
export * from "./importpressure.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "importpressure.vue"
export default component.exports